export function setHugeHeadingParallax(element: HTMLElement): void {
	element.style.setProperty("--huge-heading-parallax", "0em");
	const rect = element.getBoundingClientRect();
	const startingPoint = Math.max(0, rect.top + window.scrollY - window.innerHeight / 1.5);
	const endingPoint = rect.bottom + window.scrollY;
	const percentage = Math.min(0.5, Math.max(0, (window.scrollY - startingPoint) / (endingPoint - startingPoint) / 2));
	const slowDown = element.classList.contains("slow-down");
	const mild = element.classList.contains("mild");

	element.style.setProperty(
		"--huge-heading-parallax",
		`${Math.min(percentage / (slowDown ? 2 : 1), mild ? 0.2 : 50)}em`,
	);
}
